module.exports = __webpack_public_path__ + "img/arrow-left-square-fill.ddde55bb.svg";